'use client'
import Accordion from '../Accordion/Accordion'
import { useTranslation } from '../../context/ConfigContext'
import { CustomCmsSeller } from '../../../domain/seller'
import Icon from '../Icon/Icon'
import { Icons } from '../Icon/constants'

import { FRIDAY, MONDAY, SATURDAY, SUNDAY, THURSDAY, TUESDAY, WEDNESDAY } from './constants'
import {
  buildHoursOfDay,
  getCurrentOpeningHoursDay,
  isAlwaysClosed,
  parseOpeningHours,
} from './helper'

type SellerItemOpeningHoursProps = { seller: CustomCmsSeller }

export const SellerItemOpeningHours = ({ seller }: SellerItemOpeningHoursProps) => {
  const t = useTranslation()

  const openingHours = parseOpeningHours(seller)

  if (!openingHours || isAlwaysClosed(openingHours)) {
    return null
  }

  const mappedDayTranslation = {
    [FRIDAY]: t('Friday', {}, false),
    [MONDAY]: t('Monday', {}, false),
    [SATURDAY]: t('Saturday', {}, false),
    [SUNDAY]: t('Sunday', {}, false),
    [THURSDAY]: t('Thursday', {}, false),
    [TUESDAY]: t('Tuesday', {}, false),
    [WEDNESDAY]: t('Wednesday', {}, false),
  }

  const currentDay = getCurrentOpeningHoursDay(openingHours)

  return (
    <div className='seller-item-openinghours'>
      <div>
        <Accordion
          product={null}
          items={[
            {
              title: (
                <>
                  <Icon iconName={Icons.CLOCK} className='icon-clock' />
                  <span className='seller-item-openinghours-title'>
                    {t('Work Time Today:')}
                  </span>
                  <span className='seller-item-openinghours-title-opening-today'>
                    {buildHoursOfDay(currentDay, t)}
                  </span>
                </>
              ),
              content: (
                <ul className='seller-item-openinghours-days'>
                  {Object.keys(openingHours).map((day) => (
                    <li key={day} className='seller-item-openinghours-days-item'>
                      <span>{mappedDayTranslation[day]}</span>
                      <span>{buildHoursOfDay(openingHours[day], t)}</span>
                    </li>
                  ))}
                </ul>
              ),
            },
          ]}
        />
      </div>
    </div>
  )
}
